import React from 'react';
import style from './InfoSection.module.scss';
import {
  EmailIcon,
  LocationIcon,
  PhoneIcon,
  AvaliabilityIcon,
} from '@/public/icons/contact_us/icons';
import { microdataConfig } from '@/lib/microdata-config';

const items = [
  {
    Icon: PhoneIcon,
    title: 'Phone Number',
    value: ['(619) 349-4397'],
  },
  {
    Icon: EmailIcon,
    title: 'Email address',
    value: ['contact@tytum.com '],
  },
  {
    Icon: LocationIcon,
    title: 'Location',
    value: [
      '16950 Via De Santa Fe',
      'Suite 5060-136, Rancho Santa Fe,',
      'CA 92091',
    ],
    href: microdataConfig.local.mapUrl,
  },
  {
    Icon: AvaliabilityIcon,
    title: 'Availability',
    value: ['Monday - Sunday', '6:30am - 8pm'],
  },
];

export const InfoSection = () => {
  return (
    <ul className="flex w-full flex-col justify-between gap-6 md:flex-row">
      {items.map(({ Icon, title, value, href }, idx) => (
        <li
          style={{ background: idx === 3 ? 'none' : 'inherit' }}
          className="flex flex-col items-center"
          key={title}
        >
          <div className={style.iconWrapper}>{<Icon />}</div>
          <p className="mb-6 text-2xl font-semibold">{title}</p>
          {href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg hover:opacity-75"
            >
              {value.map((item) => (
                <span key={item} className="block">
                  {item}
                </span>
              ))}
            </a>
          ) : (
            value.map((item) => (
              <p key={item} className="text-lg">
                {item}
              </p>
            ))
          )}
        </li>
      ))}
    </ul>
  );
};
